// extracted by mini-css-extract-plugin
export default {"externalApplicationButton":"ExternalApplicationButton_externalApplicationButton__-ER+2","icon":"ExternalApplicationButton_icon__ZbND0"};